import { colors, IconButton, Typography } from '@sweep-io/sweep-design';
import { ListElementWrapper } from '../../shared/ListElementWrapper';
import { Box, Stack } from '@mui/material';
import { SelectedObjectListElements } from '../../types';
import { NoResults } from '../../shared/NoResults';
import { ChevronRight } from '@sweep-io/sweep-design/dist/icons';
import pluralize from 'pluralize';

interface MenuElementsWithBadgeProps {
  elements: SelectedObjectListElements;
  onClick: (event: any, key: any) => void;
}

export const MenuElementsWithBadge = ({ elements, onClick }: MenuElementsWithBadgeProps) => {
  return (
    <>
      {!elements.length && (
        <Box pl={2}>
          <NoResults />
        </Box>
      )}

      {elements.map((element) => {
        const key = element.value as any;

        return (
          <ListElementWrapper
            key={key}
            onWrapperClick={(event) => onClick(event, key)}
            sx={{ height: '56px', pl: 0, pr: 0 }}
            leftContent={
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  pl: 2,
                  pr: 2,

                  button: {
                    //TODO replace with new button variant SWEEP-6500
                    border: 'none',

                    svg: {
                      width: '12px',
                      height: '12px', //TODO add to ds different icon button icon sizes

                      path: {
                        stroke: colors.grey[500],
                      },
                    },
                  },
                }}
              >
                <Stack gap={0}>
                  <Typography variant="body" color={colors.grey[900]}>
                    {element.label}
                  </Typography>
                  <Typography variant="caption" color={colors.grey[700]}>
                    {element.badgeLabel} {pluralize('item', element.badgeLabel)}
                  </Typography>
                </Stack>

                <IconButton variant="system" size="tiny">
                  <ChevronRight size="medium" />
                </IconButton>
              </Box>
            }
          />
        );
      })}
    </>
  );
};
